import useAuthStore from '@/store/authStore';
import { Navigate, Outlet } from 'react-router';

const GuestRoute = () => {
  const session = useAuthStore((state) => state.session);
  const isAuthInitialized = useAuthStore((state) => state.isAuthInitialized);
  const user = useAuthStore((state) => state.user);
  const userRole = user?.role;

  if (isAuthInitialized && session?.accessToken) {
    switch (userRole) {
      case 'SUPERADMIN':
        return <Navigate to="/superadmin/dashboard" replace />;
      case 'OWNER':
        return <Navigate to="/owner/dashboard" replace />;
      case 'MANAGER':
        return <Navigate to="/manager/dashboard" replace />;
      case 'EMPLOYEE':
        return <Navigate to="/employee/dashboard" replace />;
      default:
        return <Navigate to="/404" replace />;
    }
  }

  return <Outlet />;
};

export default GuestRoute;
